import { ApplicationRef, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';

import { ConfigModule } from 'ycharts/static/ts/config/config.module';
import { LoadingSymbolModule } from 'ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.module';
import { NavigationModule } from 'ycharts/static/ts/features/components/navigation/navigation.module';
import { PasswordRevealModule } from 'ycharts/static/ts/features/components/password-controls/password-reveal/password-reveal.module';
import { IconModule } from 'ycharts/static/ts/features/directives/icon/icon.module';
import { NgModelChangeDebouncedModule } from 'ycharts/static/ts/features/directives/ng-model-change-debounced/ng-model-change-debounced.module';

import { SignupFormComponent } from 'EntitlementsApp/ts/apps/trial-signup-app/signup-form/signup-form.component';
import { TopBarNavComponent } from 'ycharts/static/ts/features/components/navigation/top-bar-nav/top-bar-nav.component';

@NgModule({
    declarations: [SignupFormComponent],
    imports: [
        BrowserModule,
        ConfigModule,
        FormsModule,
        IconModule,
        LoadingSymbolModule,
        NavigationModule,
        NgModelChangeDebouncedModule,
        PasswordRevealModule,
        StoreModule.forRoot({}),
    ],
})
export class TrialSignupApp {
    ngDoBootstrap(appRef: ApplicationRef): void {
        appRef.bootstrap(SignupFormComponent);
        appRef.bootstrap(TopBarNavComponent);
    }
}
